import React from "react"
import { BrowserRouter as Router, Switch, Route, useParams} from "react-router-dom"
import SignIn from "./SignIn/SignIn"
import MenuAppBar from "./NavBar/NavBar"
import SfpSingIn from "./SignIn/SfpSignIn"
import OidcCallback from "./SignIn/OidcCallback"

const App = () => {
	return (
		<div className="app-routes">
			<Router basename={process.env.REACT_APP_URL_ROOT_NAME}>
			<Switch>
				<Route path="/signin" component={SignIn} />
				<Route path="/oidc_callback" component={OidcCallback} />
				<Route path="/sfpsignin" component={SfpSingIn} />
				<Route path="/" component={MenuAppBar} />
			</Switch>
			</Router>
		</div>
	)
}

export default App;
